<template>

    <nav class="flex flex-1 flex-col">
        <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li>
                <ul role="list" class="-mx-2 space-y-1">
                    <template v-for="item in getNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                <span class="min-w-0 flex-1 truncate">{{ item.name }}</span>
                                <span
                                    v-if="getNavBadge(item)"
                                    class="ml-auto inline-flex min-w-5 items-center justify-center rounded-full bg-amber-400 px-1.5 py-0.5 text-[11px] font-bold leading-none text-slate-950"
                                >
                                    {{ getNavBadge(item) }}
                                </span>
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="hasLocalizeService()">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Localize</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <li v-for="item in getLocalizeNavigation()" :key="item.name">
                        <RouterLink :to="item.href" :class="getNavItemClass(item)">
                            <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                            {{ item.name }}
                        </RouterLink>
                    </li>
                </ul>
            </li>

            <li v-if="getBuilderNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Builder</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getBuilderNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="getSlotflowNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Slotflow</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getSlotflowNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="getLeadCaptureNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Lead Capture</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getLeadCaptureNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="getReviewWidgetNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Review Widget</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getReviewWidgetNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="getTicketsNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Tickets</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getTicketsNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="getReceptionNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">{{ t('reception.navigation.section') }}</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getReceptionNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="getToolNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Tools</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getToolNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <li v-if="getModuleNavigation().some(item => item.visible)">
                <div class="px-3 text-[11px] font-semibold uppercase tracking-[0.16em] text-indigo-200/70">Modules</div>
                <ul role="list" class="-mx-2 mt-2 space-y-1">
                    <template v-for="item in getModuleNavigation()" :key="item.name">
                        <li v-if="item.visible">
                            <RouterLink :to="item.href" :class="getNavItemClass(item)">
                                <component :is="item.icon" :class="getNavIconClass(item)" aria-hidden="true" />
                                {{ item.name }}
                            </RouterLink>
                        </li>
                    </template>
                </ul>
            </li>

            <!--
            <li class="-mx-2">
                <RouterLink
                    :to="{ name: 'configuration' }"
                    :class="[route.name === 'configuration' ? 'bg-indigo-700 text-white' : 'text-indigo-200 hover:bg-indigo-700 hover:text-white', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold']"
                >
                    <Cog6ToothIcon
                        :class="[route.name === 'configuration' ? 'text-white' : 'text-indigo-200 group-hover:text-white', 'size-6 shrink-0']"
                        aria-hidden="true"
                    />
                    Settings
                </RouterLink>
            </li>
            -->

        </ul>
    </nav>

</template>

<script setup>

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import {
    Cog6ToothIcon,
    CalendarDaysIcon,
    ClipboardDocumentListIcon,
    HomeIcon,
    InboxStackIcon,
    LinkIcon,
    UserGroupIcon,
    BuildingStorefrontIcon,
    LanguageIcon,
    PaperClipIcon,
    PhotoIcon,
    PercentBadgeIcon,
    RectangleGroupIcon,
    ChartBarIcon,
    DocumentCurrencyDollarIcon,
    PrinterIcon,
    ScaleIcon,
    SwatchIcon, PaintBrushIcon, WrenchIcon, CurrencyDollarIcon, DocumentTextIcon, ShoppingBagIcon, TagIcon, TruckIcon,
    PaperAirplaneIcon, RectangleStackIcon, FolderIcon, ShoppingCartIcon, TableCellsIcon, CubeIcon, CalculatorIcon,
    LockClosedIcon, MapPinIcon, DocumentIcon, Square3Stack3DIcon, ViewColumnsIcon, Bars3Icon,
    ChatBubbleLeftRightIcon,
    PhoneIcon,
} from '@heroicons/vue/24/outline'

const route     = useRoute()
const router    = useRouter()
const { t } = useI18n()

const { result } = useQuery(gql`
    query {
        currentTenant {
            id
            type
        }
    }
`)

const tenantType = computed(() => result.value?.currentTenant?.type)
const currentTenantId = computed(() => result.value?.currentTenant?.id)
const isTamepulseTenant = computed(() => tenantType.value === 'tamepulse')
const pendingApprovalCount = ref(0)
const approvalChannelName = ref(null)

const { result: pendingApprovalsResult } = useQuery(gql`
    query ($first: Int!, $page: Int, $status: String) {
        tamepulseApprovalRequestPaginated(perPage: $first, page: $page, status: $status) {
            paginatorInfo {
                total
            }
        }
    }
`, {
    first: 1,
    page: 1,
    status: 'pending',
}, {
    enabled: isTamepulseTenant,
    fetchPolicy: 'cache-and-network',
})

const setPendingApprovalCount = (value) => {
    pendingApprovalCount.value = Math.max(0, Number(value ?? 0))
}

watch(pendingApprovalsResult, (value) => {
    setPendingApprovalCount(value?.tamepulseApprovalRequestPaginated?.paginatorInfo?.total)
}, { immediate: true })

const subscribeToApprovalBadge = () => {
    leaveApprovalBadgeChannel()

    if (!window.Echo || !isTamepulseTenant.value || !currentTenantId.value) {
        return
    }

    const channelName = `tamepulse.approvals.${currentTenantId.value}`
    approvalChannelName.value = channelName

    window.Echo.channel(channelName)
        .listen('.TamepulseApprovalRequestsUpdated', (event) => {
            setPendingApprovalCount(event.pending_count)
        })
}

const leaveApprovalBadgeChannel = () => {
    if (window.Echo && approvalChannelName.value) {
        window.Echo.leave(approvalChannelName.value)
    }

    approvalChannelName.value = null
}

watch([isTamepulseTenant, currentTenantId], subscribeToApprovalBadge, { immediate: true })

onBeforeUnmount(leaveApprovalBadgeChannel)

const isNicheraTenant = () => result.value?.currentTenant?.type === 'nichera'
const isQuoteTenant = () => result.value?.currentTenant?.type === 'quote'
const isReceptionTenant = () => result.value?.currentTenant?.type === 'reception'

const getNavBadge = (item) => {
    const badge = Number(item.badge ?? 0)

    if (badge <= 0) {
        return null
    }

    return badge > 99 ? '99+' : String(badge)
}

const getNavItemClass = (item) => {
    return [
        item.current
            ? 'bg-white/16 text-white shadow-sm ring-1 ring-white/10'
            : 'text-indigo-100/85 hover:bg-white/10 hover:text-white',
        'group flex items-center gap-x-3 rounded-xl px-3 py-2.5 text-sm font-semibold transition duration-150',
    ]
}

const getNavIconClass = (item) => {
    return [
        item.current
            ? 'text-white'
            : 'text-indigo-200/80 group-hover:text-white',
        'size-5 shrink-0 transition',
    ]
}

const getNavigation     = () => {

    let navigation      = [
        {
            name        : t('tamepulse.navigation.dashboard'),
            href        : router.resolve({ name: 'dashboard.index' }).href,
            icon        : HomeIcon,
            current     : route.name === 'dashboard.index',
            visible     : true
        },
        {
            name        : t('tamepulse.navigation.apps'),
            href        : router.resolve({ name: 'apps.index', params: { tenantId: route.params.tenantId } }).href,
            icon        : Square3Stack3DIcon,
            current     : route.name === 'apps.index',
            visible     : true
        }
    ]

    navigation.push({
        name        : 'Calcura',
        href        : router.resolve({ name: 'calcura.calculator.index' }).href,
        icon        : CalculatorIcon,
        current     : route.name === 'calcura.calculator.index',
        visible     : result.value?.currentTenant?.type === 'calcura'
    })

    navigation.push({
        name        : 'Stores',
        href        : router.resolve({ name: 'store.index' }).href,
        icon        : MapPinIcon,
        current     : route.name?.startsWith('store.'),
        visible     : result.value?.currentTenant?.type === 'store_locator'
    })

    if (result.value?.currentTenant?.type === 'tamepulse') {
        navigation.push(...getTamepulseNavigation())
    }

    if (result.value?.currentTenant?.type === 'quote') {
        navigation.push(...getQuoteNavigation())
    }

    navigation.push({
        name        : 'Customers',
        href        : router.resolve({ name: 'customer.index' }).href,
        icon        : UserGroupIcon,
        current     : route.name === 'customer.index',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Product categories',
        href        : router.resolve({ name: 'entity.index', params: { entityType: 'category' } }).href,
        icon        : FolderIcon,
        current     : route.name?.startsWith('entity.') && route.params?.entityType === 'category',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Products',
        href        : router.resolve({ name: 'product.index' }).href,
        icon        : ShoppingBagIcon,
        current     : route.name === 'product.index',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Orders',
        href        : router.resolve({ name: 'order.index' }).href,
        icon        : ShoppingCartIcon,
        current     : route.name === 'order.index',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Media Library',
        href        : router.resolve({ name: 'media-library.index' }).href,
        icon        : PhotoIcon,
        current     : route.name === 'media-library.index',
        visible     : ['nichera', 'website'].includes(result.value?.currentTenant?.type)
    })

    navigation.push({
        name        : 'Discount groups',
        href        : router.resolve({ name: 'discount-group.index' }).href,
        icon        : RectangleGroupIcon,
        current     : route.name === 'discount-group.index',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Discounts',
        href        : router.resolve({ name: 'discount.index' }).href,
        icon        : PercentBadgeIcon,
        current     : route.name === 'discount.index',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Tags',
        href        : router.resolve({ name: 'entity.index', params: { entityType: 'tag' } }).href,
        icon        : TagIcon,
        current     : route.name?.startsWith('entity.') && route.params?.entityType === 'tag',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Courier',
        href        : router.resolve({ name: 'courier.index' }).href,
        icon        : TruckIcon,
        current     : route.name === 'courier.index',
        visible     : isNicheraTenant()
    })

    navigation.push({
        name        : 'Shipping taxes',
        href        : router.resolve({ name: 'shipping.index' }).href,
        icon        : PaperAirplaneIcon,
        current     : route.name === 'shipping.taxes',
        visible     : isNicheraTenant()
    })

    return navigation
}

const getBuilderNavigation = () => {

    const isBuilder = ['nichera', 'website'].includes(result.value?.currentTenant?.type)

    return [
        {
            name    : 'Pagine',
            href    : router.resolve({ name: 'entity.index', params: { entityType: 'page' } }).href,
            icon    : DocumentIcon,
            current : route.name?.startsWith('entity.') && route.params?.entityType === 'page',
            visible : isBuilder
        },
        {
            name    : 'Articoli',
            href    : router.resolve({ name: 'entity.index', params: { entityType: 'post' } }).href,
            icon    : ClipboardDocumentListIcon,
            current : route.name?.startsWith('entity.') && route.params?.entityType === 'post',
            visible : isBuilder
        },
        {
            name    : 'Categorie articoli',
            href    : router.resolve({ name: 'entity.index', params: { entityType: 'post_category' } }).href,
            icon    : FolderIcon,
            current : route.name?.startsWith('entity.') && route.params?.entityType === 'post_category',
            visible : isBuilder
        },
        {
            name    : 'Template',
            href    : router.resolve({ name: 'entity.index', params: { entityType: 'page_template' } }).href,
            icon    : RectangleStackIcon,
            current : route.name?.startsWith('entity.') && route.params?.entityType === 'page_template',
            visible : isBuilder
        },
        {
            name    : 'Global blocks',
            href    : router.resolve({ name: 'entity.index', params: { entityType: 'global_block' } }).href,
            icon    : ViewColumnsIcon,
            current : route.name?.startsWith('entity.') && route.params?.entityType === 'global_block',
            visible : isBuilder
        },
        {
            name    : 'Menu',
            href    : router.resolve({ name: 'menu.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : Bars3Icon,
            current : route.name?.startsWith('menu.'),
            visible : isBuilder
        },
        {
            name    : 'Categorie pagine',
            href    : router.resolve({ name: 'entity.index', params: { entityType: 'page_category' } }).href,
            icon    : FolderIcon,
            current : route.name?.startsWith('entity.') && route.params?.entityType === 'page_category',
            visible : isBuilder
        },
        {
            name    : 'Global settings',
            href    : router.resolve({ name: 'builder.global-settings', params: { tenantId: route.params.tenantId } }).href,
            icon    : PaintBrushIcon,
            current : route.name === 'builder.global-settings',
            visible : isBuilder
        },
        {
            name    : 'Themes',
            href    : router.resolve({ name: 'builder.themes', params: { tenantId: route.params.tenantId } }).href,
            icon    : SwatchIcon,
            current : route.name === 'builder.themes',
            visible : isBuilder
        },
        {
            name    : 'Site languages',
            href    : router.resolve({ name: 'locale-configuration', params: { tenantId: route.params.tenantId } }).href,
            icon    : LanguageIcon,
            current : route.name === 'locale-configuration',
            visible : isBuilder
        },
    ]
}

const getSlotflowNavigation = () => {
    const isSlotflow = result.value?.currentTenant?.type === 'slotflow'

    return [
        {
            name    : 'Forms',
            href    : router.resolve({ name: 'slotflow.form.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : CalendarDaysIcon,
            current : route.name?.startsWith('slotflow.form.'),
            visible : isSlotflow
        },
        {
            name    : 'Calendar connections',
            href    : router.resolve({ name: 'slotflow.calendar-connection.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : LinkIcon,
            current : route.name?.startsWith('slotflow.calendar-connection.'),
            visible : isSlotflow
        },
        {
            name    : 'Bookings',
            href    : router.resolve({ name: 'slotflow.booking.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : ClipboardDocumentListIcon,
            current : route.name?.startsWith('slotflow.booking.'),
            visible : isSlotflow
        },
        {
            name    : 'Submissions',
            href    : router.resolve({ name: 'slotflow.submission.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : InboxStackIcon,
            current : route.name?.startsWith('slotflow.submission.'),
            visible : false
        },
    ]
}

const getLeadCaptureNavigation = () => {
    const isLeadCapture = result.value?.currentTenant?.type === 'lead_capture'

    return [
        {
            name    : 'Forms',
            href    : router.resolve({ name: 'lead-capture.form.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : DocumentTextIcon,
            current : route.name?.startsWith('lead-capture.form.'),
            visible : isLeadCapture
        },
        {
            name    : 'Submissions',
            href    : router.resolve({ name: 'lead-capture.submission.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : InboxStackIcon,
            current : route.name?.startsWith('lead-capture.submission.'),
            visible : isLeadCapture
        },
    ]
}

const getReviewWidgetNavigation = () => {
    const isReviewWidget = result.value?.currentTenant?.type === 'review_widget'

    return [
        {
            name    : 'Forms',
            href    : router.resolve({ name: 'review-widget.form.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : DocumentTextIcon,
            current : route.name?.startsWith('review-widget.form.'),
            visible : isReviewWidget
        },
        {
            name    : 'Reviews',
            href    : router.resolve({ name: 'review-widget.review.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : InboxStackIcon,
            current : route.name?.startsWith('review-widget.review.'),
            visible : isReviewWidget
        },
    ]
}

const getTicketsNavigation = () => {

    const isTickets = result.value?.currentTenant?.type === 'tickets'

    return [
        {
            name    : 'Tickets',
            href    : router.resolve({ name: 'ticket.index' }).href,
            icon    : InboxStackIcon,
            current : route.name?.startsWith('ticket.'),
            visible : isTickets
        },
        {
            name    : 'Contracts',
            href    : router.resolve({ name: 'contract.index' }).href,
            icon    : DocumentTextIcon,
            current : route.name?.startsWith('contract.'),
            visible : isTickets
        },
        {
            name    : 'Contacts',
            href    : router.resolve({ name: 'contact.index' }).href,
            icon    : BuildingStorefrontIcon,
            current : route.name?.startsWith('contact.'),
            visible : isTickets
        },
        {
            name    : 'Customers',
            href    : router.resolve({ name: 'customer.index' }).href,
            icon    : UserGroupIcon,
            current : route.name?.startsWith('customer.'),
            visible : isTickets
        },
    ]
}

const getQuoteNavigation = () => {
    const isQuote = isQuoteTenant()

    return [
        {
            name    : t('quote.navigation.requests'),
            href    : router.resolve({ name: 'quote.sales-request.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : InboxStackIcon,
            current : route.name?.startsWith('quote.sales-request.'),
            visible : isQuote
        },
        {
            name    : t('quote.navigation.quotes'),
            href    : router.resolve({ name: 'quote.quote.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : DocumentCurrencyDollarIcon,
            current : route.name?.startsWith('quote.quote.'),
            visible : isQuote
        },
        {
            name    : t('quote.navigation.accounts'),
            href    : router.resolve({ name: 'quote.account.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : BuildingStorefrontIcon,
            current : route.name?.startsWith('quote.account.'),
            visible : isQuote
        },
        {
            name    : t('quote.navigation.people'),
            href    : router.resolve({ name: 'quote.person.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : UserGroupIcon,
            current : route.name?.startsWith('quote.person.'),
            visible : isQuote
        },
        {
            name    : t('quote.navigation.followUps'),
            href    : router.resolve({ name: 'quote.follow-up.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : CalendarDaysIcon,
            current : route.name?.startsWith('quote.follow-up.'),
            visible : isQuote
        },
    ]
}

const getReceptionNavigation = () => {
    const isReception = isReceptionTenant()

    return [
        {
            name    : t('reception.navigation.dashboard'),
            href    : router.resolve({ name: 'reception.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : ChartBarIcon,
            current : route.name === 'reception.index',
            visible : isReception
        },
        {
            name    : t('reception.navigation.calls'),
            href    : router.resolve({ name: 'reception.call.index', params: { tenantId: route.params.tenantId } }).href,
            icon    : PhoneIcon,
            current : route.name?.startsWith('reception.call.'),
            visible : isReception
        },
    ]
}

const getTamepulseNavigation  = () => {

    const isTamepulse = result.value?.currentTenant?.type === 'tamepulse'

    return [
        {
            name    : t('tamepulse.navigation.connections'),
            href    : router.resolve({ name: 'tamepulse.connection' }).href,
            icon    : Cog6ToothIcon,
            current : route.name?.startsWith('tamepulse.connection'),
            visible : isTamepulse
        },
        {
            name    : t('tamepulse.navigation.chat'),
            href    : router.resolve({ name: 'tamepulse.chat.index' }).href,
            icon    : ChatBubbleLeftRightIcon,
            current : route.name?.startsWith('tamepulse.chat.'),
            visible : isTamepulse
        },
        {
            name    : t('tamepulse.navigation.playbooks'),
            href    : router.resolve({ name: 'tamepulse.playbook.index' }).href,
            icon    : RectangleStackIcon,
            current : route.name?.startsWith('tamepulse.playbook.'),
            visible : isTamepulse
        },
        {
            name    : t('tamepulse.navigation.templates'),
            href    : router.resolve({ name: 'tamepulse.template.index' }).href,
            icon    : Square3Stack3DIcon,
            current : route.name?.startsWith('tamepulse.template.'),
            visible : isTamepulse
        },
        {
            name    : t('tamepulse.navigation.approvals'),
            href    : router.resolve({ name: 'tamepulse.approval.index' }).href,
            icon    : InboxStackIcon,
            current : route.name?.startsWith('tamepulse.approval.'),
            visible : isTamepulse,
            badge   : pendingApprovalCount.value
        },
    ]
}

const getToolNavigation      = () => {

    let navigation       = [
        {
            name        : 'Product types',
            href        : router.resolve({ name: 'product-type.index' }).href,
            icon        : CubeIcon,
            current     : route.name === 'product-type.index',
            visible     : isNicheraTenant()
        },

        {
            name        : 'Product attributes',
            href        : router.resolve({ name: 'product-attribute.index' }).href,
            icon        : TableCellsIcon,
            current     : route.name === 'product-attribute.index',
            visible     : isNicheraTenant()
        },

        {
            name        : 'Notification settings',
            href        : router.resolve({ name: 'notification.index' }).href,
            icon        : WrenchIcon,
            current     : route.name === 'notification.index',
            visible     : isNicheraTenant()
        },

        {
            name        : 'Currency rates',
            href        : router.resolve({ name: 'currency-rate.index' }).href,
            icon        : CurrencyDollarIcon,
            current     : route.name === 'currency-rate.index',
            visible     : isNicheraTenant()
        },

        {
            name        : 'Tasks',
            href        : router.resolve({ name: 'task.index' }).href,
            icon        : RectangleStackIcon,
            current     : route.name === 'task.index',
            visible     : ['nichera', 'store_locator'].includes(result.value?.currentTenant?.type)
        },

        {
            name        : 'API Tokens',
            href        : router.resolve({ name: 'public-token.edit' }).href,
            icon        : LockClosedIcon,
            current     : route.name === 'public-token.edit',
            visible     : isNicheraTenant()
        }
    ];

    return navigation
}

const getModuleNavigation      = () => {

    let navigation       = []

    const isNichera = isNicheraTenant()

    navigation.push({
        name        : 'Attachments',
        href        : router.resolve({ name: 'attachment.index' }).href,
        icon        : PaperClipIcon,
        current     : route.name === 'attachment.index',
        visible     : isNichera,
    })

    navigation.push({
        name        : 'Color groups',
        href        : router.resolve({ name: 'entity.index', params: { entityType: 'color_group' } }).href,
        icon        : SwatchIcon,
        current     : route.name?.startsWith('entity.') && route.params?.entityType === 'color_group',
        visible     : isNichera,
    })

    navigation.push({
        name        : 'Colors',
        href        : router.resolve({ name: 'entity.index', params: { entityType: 'color' } }).href,
        icon        : PaintBrushIcon,
        current     : route.name?.startsWith('entity.') && route.params?.entityType === 'color',
        visible     : isNichera,
    })

    navigation.push({
        name        : 'Print costs',
        href        : router.resolve({ name: 'entity.index', params: { entityType: 'print_cost' } }).href,
        icon        : ScaleIcon,
        current     : route.name?.startsWith('entity.') && route.params?.entityType === 'print_cost',
        visible     : isNichera,
    })

    navigation.push({
        name        : 'Print techniques',
        href        : router.resolve({ name: 'entity.index', params: { entityType: 'print_technique' } }).href,
        icon        : PrinterIcon,
        current     : route.name?.startsWith('entity.') && route.params?.entityType === 'print_technique',
        visible     : isNichera,
    })

    navigation.push({
        name        : 'Print handling charge',
        href        : router.resolve({ name: 'print-handling-charge.index' }).href,
        icon        : DocumentCurrencyDollarIcon,
        current     : route.name === 'print-handling-charge.index',
        visible     : isNichera,
    })

    navigation.push({
        name        : 'Certificates',
        href        : router.resolve({ name: 'entity.index', params: { entityType: 'certificate' } }).href,
        icon        : DocumentTextIcon,
        current     : route.name?.startsWith('entity.') && route.params?.entityType === 'certificate',
        visible     : isNichera,
    })

    return navigation
}
const hasLocalizeService         = () => {

    return false;

    let hasLocalize    = false

    /*
    for(const userService of usePage().props.user.services){

        if(userService.service._id == '67978ac31c6d6545730aa6f2'){
            hasLocalize     = true
        }
    }
    */

    return hasLocalize
}

const getLocalizeNavigation      = () => {

    let navigation       = []

    navigation.push({
        name        : 'String translation',
        href        : '#',
        icon        : LanguageIcon,
        current     : ''
    });

    return navigation
}


</script>
